module.exports = __webpack_public_path__ + "img/icon_sports_rowing.e1aa01ea.png";